<div class="container-fluid">
  <!-- Header-->
  <header>
    <div class="row ey-header-container">
      <div class="col-sm-12">
        <h1 class="ey-header">No Study Access</h1>
      </div>
    </div>
  </header>
  <!-- Header-->

  <!--Content-->
  <div class="ey-content mt-3">
    <div class="col-sm-12">
      <i class="material-icons err-icon"> error </i>
      <span class="text-dark err-mssg">Sorry, it looks like your account does not have access to any studies.</span>
    </div>
  </div>
  <!--Content-->
</div>
